/**
 * ADGMQ
 * imedia
 *
 * Lightbox
 */

(function($) {
  $(document).ready(function() {
    /**
     * Init SimpleLightbox
     */
    if ($('.gallery__lightbox').length) {
      $('.gallery__lightbox a').simpleLightbox({
        captionsData: 'title',
      });
    }
  });
})(jQuery);
